import { Dialog } from "primereact/dialog";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from "primereact/button";
import { JVDropdown } from "../../../../shared/JVDropdown";
import { JVInput } from "../../../../shared/JVInput";
import { Fetch } from "../../../../shared/Fetch";
import { useEffect, useState } from "react";
import { ITrainer } from "./Table";
import { MultiSelect } from "primereact/multiselect";
import { IRolesDropdown, IUsersDropdown } from "../../../../models/IDropdown";

interface IProps {
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadTable: () => void,
}

interface ITrainnerUsers {
    role_ID?: number,
    login_IDs?: number[],
}

const schema = yup.object({
    role_ID: yup.number().required("Role is required"),
    login_ID: yup.array().of(yup.number().nullable()).nullable()
});

export const Form = (props: IProps) => {
    const [users, setUsers] = useState<Array<IUsersDropdown>>([]);
    const [roles, setRoles] = useState<Array<IRolesDropdown>>([]);
    const [selectedUsers, setSelectedUsers] = useState<Array<number>>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [shwUsers, setShwUsers] = useState<boolean>(false);
    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<ITrainnerUsers>({
        resolver: yupResolver(schema),
        defaultValues: { role_ID: 0, login_IDs: [] },
        shouldFocusError: false
    });

    const onHide = () => {
        setSelectedUsers([]);
        setLoading(false);
        setShwUsers(false);
        props.reloadTable();
        props.hideDialog();
    }

    const onSubmit = async (data: ITrainnerUsers) => {
        if (selectedUsers.length > 0) {
            setLoading(true);
            const method = "POST";
            const message = "Added Successfully";

            data.login_IDs = selectedUsers;
            delete data.role_ID;

            const response = await Fetch("CarnivalTraining/addTrainer", method, data, null, props.toast);

            if (response) {
                setLoading(false);
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                onHide();
            } else setLoading(false);
        } else props.toast.current.show({ severity: 'error', detail: "Please Select atleast 1 trainer", life: 3000 });
    }

    const loadRoles = async () => {
        const response = await Fetch("CarnivalTraining/getRoles", "GET", null, null, props.toast);
        if (response) {
            const data: IRolesDropdown[] = await response.json();
            setRoles(data);
        }
    }

    const loadUsers = async (roleID: number) => {
        const response = await Fetch("CarnivalTraining/getUsersByRole", "GET", null, `role_ID=${roleID}`, props.toast);
        if (response) {
            const data: IUsersDropdown[] = await response.json();
            setUsers(data.map((ele: any) => {
                return { ...ele, user_Name: ele.user_Name + " (" + (ele.company_Name || "").split(" ")[0] + " - " + (ele.branchName || "") + ") " };
            }));
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "role_ID") {
                if (value.role_ID != 0 && value.role_ID != null) {
                    loadUsers(value.role_ID);
                    setShwUsers(true);
                } else {
                    loadUsers(0);
                    setShwUsers(false);
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch, shwUsers]);

    useEffect(() => {
        if (props.open) {
            loadRoles();
            reset({ role_ID: 0, login_IDs: [] });
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '40vw' }} header="Add Trainers" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown column={3} required label="Role" control={control} name="role_ID" options={roles} optionLabel="role_Name" optionValue="role_ID" placeholder="Select Role" error={errors.role_ID?.message} />
                <div className="field col-2 md:col-6">
                    <p>Users</p>
                    <MultiSelect disabled={!shwUsers} className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedUsers} onChange={(e) => setSelectedUsers(e.value)} options={users} optionValue="login_ID" optionLabel="user_Name" display="chip" filter placeholder="Select Trainers" />
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit" loading={loading} disabled={loading} ></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </form>
        </Dialog>
    );
}